export const createDivEl = (txt, clsName) => {
  const divEl = document.createElement("div")
  divEl.className = clsName
  divEl.innerHTML = txt
  return divEl
}

export const createImgEl = (img, clsName) => {
  const imgEl = document.createElement("img")
  imgEl.className = clsName
  imgEl.src = img
  return imgEl
}
